import React from 'react'
import { useDrag } from 'react-dnd'

const TopicDragItem = ({ name, parentId, typeItem, id, chart }) => {
    const [{ opacity }, drag] = useDrag({
        item: { type: 'box', name, parentId, id, typeItem, chart},
        options: {
            dropEffect: 'copy',
        },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.9 : 1,
        }),
    });

    return (
        <li ref={drag} className='form-input' style={{opacity, listStyle: 'none'}}>
            {name}
        </li>
    )
};

export default TopicDragItem
